/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import {
  Modal,
  Icon,
  Table,
  Ref,
  Checkbox,
  Input,
  Portal,
  ModalDescription,
  TextArea,
  Loader,
  Dropdown,
  Header,
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import cx from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import Update from 'immutability-helper';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import api from '../../api';
import ClarLoader from '../Loader/Loader';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import dragbarImg from '../../images/components/my/drager.svg';
import ResultRenderer from '../ResultRenderer/ResultRenderer';
import ResultRendererWithPath from '../ResultRenderer/ResultRendererWithPath';
import WithRouter from '../Extensions/WithRouter';
import EditCveCodeModal from './EditCveCodeModal';

class ScanResultModal extends Component {
  constructor(props) {
    super(props);
    this.typingTimeout = null;
    this.state = {
      isLoading: false,
      isChange: false,
      activeIndex: '',
      currentId: '',
      errorIndex: [],
      selectedRowIds: [],
      resultList: [],
      resultFileList: [],
      revertList: [],
      selectedResultData: {},
      cveList: [],
      errorMessage: '',
      limit: 25,
      isOpenCVE: false,
      currentCVEIndex: '',
      allSelected: false,
      titleLicenseLoadingIndex: [],
      securitiesLoadingIndex: [],
      checksum: '',
      comment: '',
      components: [],
      coverage: 'company',
      hasGlobalPermission: false,
      isApplied: false,
      name: '',
      revertFileName: '',
      //projectId: '',
      //projectName: '',
      //projectVersionId: '',
      //projectVersionName: '',
      //uploadedFileId: '',
      isActiveResult: false,
      isOpenAlertModal: false,
      isLoadingFileScroll: false,
      blurTriggered: false,
      selectedResultFileData: {},
    };
    this.handleAddRow = this.handleAddRow.bind(this);
    this.handleDeleteRow = this.handleDeleteRow.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlurOnName = this.handleBlurOnName.bind(this);
    this.handleBlurOnVersion = this.handleBlurOnVersion.bind(this);
    this.handleBlurOnLicense = this.handleBlurOnLicense.bind(this);
    this.handleResultSelect = this.handleResultSelect.bind(this);
    this.handleApplyNextScanChange = this.handleApplyNextScanChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCVEModalChange = this.handleCVEModalChange.bind(this);
    this.handleCVEDataChange = this.handleCVEDataChange.bind(this);
    this.handleCheckAllChange = this.handleCheckAllChange.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handleTextAreaChange = this.handleTextAreaChange.bind(this);
    this.handleFileNameChange = this.handleFileNameChange.bind(this);
    this.handleFileNameFocus = this.handleFileNameFocus.bind(this);
    this.handleFileNameBlur = this.handleFileNameBlur.bind(this);
    this.handleFileNameResultSelect = this.handleFileNameResultSelect.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.searchFilesForReport = this.searchFilesForReport.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeCVEModal = this.closeCVEModal.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.validateForm = this.validateForm.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isOpenMSR } = this.props;

    if (isOpenMSR !== prevProps.isOpenMSR) {
      this.setState(
        {
          activeIndex: '',
          isChange: !isOpenMSR,
          errorMessage: '',
          errorIndex: [],
          isOpenCVE: false,
          cveList: [],
          titleLicenseLoadingIndex: [],
          securitiesLoadingIndex: [],
          selectedResultData: {},
          checksum: '',
          comment: '',
          components: [],
          coverage: 'company',
          hasGlobalPermission: false,
          isApplied: false,
          name: '',
          revertFileName: '',
          //projectId: '',
          //projectName: '',
          //projectVersionId: '',
          //projectVersionName: '',
          //uploadedFileId: '',
          isActiveResult: false,
          isOpenAlertModal: false,
          isLoadingFileScroll: false,
          blurTriggered: false,
          selectedResultFileData: {},
          isLoading: false,
          resultFileList: [],
        },
        () => {
          if (isOpenMSR) {
            this.getEmptyReportForEdit();
          }
        }
      );
    }
  }

  componentWillUnmount() {
    clearTimeout(this.typingTimeout);
  }

  handleSave() {
    let req;
    const {
      components, isApplied, comment, coverage, selectedResultFileData
    } = this.state;

    const {
      state, translate, reportId, handleSaveCallback
    } = this.props;

    const newComponent = components.map((item) => {
      return {
        component_name: item.component_name,
        component_version: item.component_version,
        title_license: item.title_license,
        securities: item.securities,
      };
    });

    if (state.user.currentPrecisionLevel) {
      req = {
        components: newComponent,
        is_applied: isApplied,
        precision_level: state.user.currentPrecisionLevel,
      };
    } else {
      req = {
        components: newComponent,
        is_applied: isApplied,
      };
    }

    if (req.is_applied) {
      req.coverage = coverage;
      req.comment = comment;
    }

    req.name = selectedResultFileData.name;
    req.size = selectedResultFileData.size;
    req.path = selectedResultFileData.path;
    req.realpath = selectedResultFileData.realpath;
    req.relative_name = selectedResultFileData.relative_name;
    req.checksum = selectedResultFileData.checksum;
    req.scan_method = selectedResultFileData.scan_method;
    req.scan_status = selectedResultFileData.scan_status;
    req.scan_time = selectedResultFileData.scan_time;
    req.parent_name = selectedResultFileData.parent_name;

    const validateObj = components.map((item) => {
      return this.validateForm(item);
    });

    if (validateObj.indexOf(false) > -1) {
      return;
    }

    this.setState({
      isLoading: true,
    });

    api
      .saveEmptyReport(reportId, req)
      .then(() => {
        this.setState({
          isLoading: false,
        });
        handleSaveCallback();
        this.closeModal();
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;

        this.setState({
          isLoading: false,
        });

        if (o.error === '422-671') {
          return this.setState({
            errorMessage: translate('modal.message.required_component_name'),
          });
        }

        if (o.error === '422-674') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_component_name'),
          });
        }

        if (o.error === '422-675') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_component_version'),
          });
        }
        if (o.error === '422-676') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_title_license'),
          });
        }
        if (o.error === '422-677') {
          return this.setState({
            errorMessage: translate('modal.message.required_is_apply'),
          });
        }

        if (o.error === '422-679') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_security'),
          });
        }

        if (o.error === '422-680') {
          return this.setState({
            errorMessage: translate('modal.message.required_title_license'),
          });
        }

        if (o.error === '422-692') {
          return this.setState({
            errorMessage: translate('modal.message.invalid_coverage'),
          });
        }

        if (o.error === '422-681') {
          return this.setState({
            errorMessage: translate(
              'modal.message.duplicate_component_version'
            ),
          });
        }

        if (o.error === '422-683') {
          return this.setState({
            errorMessage: translate('modal.message.error_422_683_scan_result'),
          });
        }

        if (o.error_description) {
          this.setState({
            errorMessage: o.error_description,
          });
        } else {
          this.setState({
            errorMessage: translate('modal.error.unknow_error'),
          });
        }
      });
  }

  handleCheckAllChange() {
    const { components, allSelected } = this.state;
    if (allSelected) {
      return this.setState({
        selectedRowIds: [],
        allSelected: false,
      });
    }
    const newState = components.map((item) => {
      return item.id;
    });

    this.setState({
      selectedRowIds: newState,
      allSelected: true,
    });
  }

  handleCheckChange(e, { value }) {
    const { selectedRowIds } = this.state;
    let newState;

    if (selectedRowIds.indexOf(value) > -1) {
      newState = selectedRowIds.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...selectedRowIds, value];
    }

    this.setState({
      selectedRowIds: newState,
    });
  }

  handleDeleteRow() {
    const { selectedRowIds, components } = this.state;
    const newState = components.filter((item) => {
      return selectedRowIds.indexOf(item.id) === -1;
    });

    this.setState({
      components: newState,
      selectedRowIds: [],
    });
  }

  handleAddRow() {
    const { components } = this.state;
    const customIds = [];

    const existIds = components.map((item) => {
      return item.id;
    });

    while (customIds.length < 1) {
      const r = uuidv4();
      if (existIds.indexOf(r) === -1) {
        customIds.push(r);
      }
    }

    const newData = {
      component_name: '',
      component_version: '',
      title_license: '',
      securities: [],
      id: customIds[0],
    };

    this.setState({
      components: Update(components, {
        $unshift: [newData],
      }),
    });
  }

  handleChange = (id, dataType, value) => {
    const { components } = this.state;
    let processedValue;

    if (dataType === 'component_name' || dataType === 'component_version') {
      processedValue = value.toLowerCase().replace(/\s/g, '');
    } else if (dataType === 'title_license') {
      processedValue = value.replace(/\s/g, '');
    } else {
      processedValue = value;
    }

    if (value.length !== 0 && dataType !== 'title_license') {
      if (!this.textValidation(dataType, value)) {
        return;
      }
    }

    const newData = components.map((item) => {
      if (item.id !== id) {
        return item;
      }
      return {
        ...item,
        [dataType]: processedValue,
      };
    });

    this.setState({
      components: newData,
      resultList: [],
      activeIndex: '',
      currentId: id,
    });

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(() => {
      if (processedValue === '' && dataType !== 'component_version') {
        this.setState({ resultList: [] });
        return;
      }
      const edtingindex = components.findIndex((item) => {
        return item.id === id;
      });
      if (dataType === 'component_name') {
        this.searchComponentName(processedValue, dataType);
      } else if (dataType === 'component_version') {
        this.searchComponentVersion(
          processedValue,
          dataType,
          components[edtingindex].component_name
        );
      } else if (dataType === 'title_license') {
        this.searchComponentLicense(processedValue, dataType);
      }
    }, 1000);
  };

  handleFocus = (id, dataType, value) => {
    const { components } = this.state;
    const edtingindex = components.findIndex((item) => item.id === id);

    const searchKeyword = value;

    this.setState(
      {
        currentId: id,
        selectedResultData: {},
        activeIndex: '',
        resultList: [],
      },
      () => {
        const componentName = components[edtingindex]?.component_name;
        if (dataType === 'component_name') {
          this.searchComponentName(searchKeyword, dataType);
        } else if (dataType === 'component_version') {
          this.searchComponentVersion(
            searchKeyword,
            dataType,
            componentName || ''
          );
        } else if (dataType === 'title_license') {
          this.searchComponentLicense(searchKeyword, dataType);
        }
      }
    );
  };

  handleBlurOnName = (id) => {
    const { components, selectedResultData } = this.state;

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = null;
    }

    const editingIndex = components.findIndex((item) => {
      return item.id === id;
    });

    if (!selectedResultData || Object.keys(selectedResultData).length === 0) {
      return this.updateStateAndValidation({
        currentId: id,
        activeIndex: '',
        components: this.resetComponentFields(components, editingIndex),
      });
    }

    return this.updateStateAndValidation({
      currentId: id,
      activeIndex: '',
      selectedResultData: {},
    });
  };

  handleBlurOnVersion = (id) => {
    const { components, selectedResultData } = this.state;

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = null;
    }

    const editingIndex = components.findIndex((item) => {
      return item.id === id;
    });
    const currentComponent = components[editingIndex];
    const inputValue = currentComponent.component_version.trim();

    if (
      Object.keys(selectedResultData).length === 0 && selectedResultData.constructor === Object && inputValue === ''
    ) {
      return this.setState({
        currentId: id,
        activeIndex: '',
      });
    }

    if (
      Object.keys(selectedResultData).length === 0 && selectedResultData.constructor === Object
    ) {
      const { component_name, component_version } = currentComponent;
      if (component_name && component_version) {
        this.setState(
          {
            activeIndex: '',
            currentId: '',
          },
          () => {
            this.fetchAndUpdateComponentDetails(
              components,
              component_name,
              component_version,
              id
            );
          }
        );
      }
    }
  };

  handleBlurOnLicense = (id) => {
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = null;
    }
    return this.setState({
      currentId: id,
      activeIndex: '',
    });
  };

  handleApplyNextScanChange() {
    this.setState((prevState) => {
      return {
        isApplied: !prevState.isApplied,
      };
    });
  }

  handleResultSelect = async (e, result) => {
    const { currentId, components } = this.state;

    const currentIndex = components.findIndex((item) => {
      return item.id === currentId;
    });
    const updatedComponentList = [...components];

    updatedComponentList[currentIndex][result.data_type] = result.name;

    this.setState({
      components: updatedComponentList,
      activeIndex: '',
      selectedResultData: result,
      currentId: '',
    });

    if (result.data_type === 'component_version') {
      const { component_name } = components[currentIndex];
      const component_version = result.name;

      await this.fetchAndUpdateComponentDetails(
        updatedComponentList,
        component_name,
        component_version,
        currentId
      );
    }
  };

  handleCVEModalChange = (row, index) => {
    this.setState({
      isOpenCVE: true,
      cveList: row,
      currentCVEIndex: index,
    });
  };

  handleCVEDataChange = (rowData) => {
    const { currentCVEIndex, components } = this.state;

    const newData = rowData.map((item) => {
      return {
        code: item.code,
        risk: item.risk,
      };
    });

    const updatedComponentList = components.map((component, index) => {
      if (index === currentCVEIndex) {
        return {
          ...component,
          securities: newData,
        };
      }
      return component;
    });

    this.setState({
      components: updatedComponentList,
      currentCVEIndex: '',
      isChange: true,
    });
  };

  handleOptionChange(e, { value }) {
    const { coverage } = this.state;

    if (coverage === value) {
      return;
    }

    this.setState({
      coverage: value,
      isChange: true,
    });
  }

  handleTextAreaChange(e, { value }) {
    this.setState({
      comment: value,
      isChange: true,
    });
  }

  handleFileNameChange(e) {
    const string = e.target.value;

    this.setState({
      name: string,
    });

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    if (string === '') {
      this.setState({
        revertFileName: '',
        selectedResultFileData: {},
      });
    }

    this.typingTimeout = setTimeout(() => {
      this.searchFilesForReport(string, 1);
    }, 1000);
  }

  handleFileNameFocus() {
    const { name, revertFileName } = this.state;
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    const searchKeyword = '';

    this.setState({
      selectedResultData: {},
    });

    if (name === revertFileName) {
      this.typingTimeout = setTimeout(() => {
        this.searchFilesForReport(name, 1);
      }, 300);
    } else {
      this.typingTimeout = setTimeout(() => {
        this.searchFilesForReport(searchKeyword, 1);
      }, 300);
    }
  }

  handleFileNameBlur() {
    const { selectedResultFileData, revertFileName } = this.state;

    if (Object.keys(selectedResultFileData).length === 0) {
      this.setState({
        name: revertFileName,
      });
    }
    this.setState({
      isActiveResult: false,
      blurTriggered: true,
    });
  }

  handleFileNameResultSelect = (e, result) => {
    this.setState({
      isActiveResult: false,
      name: result.name,
      checksum: result.checksum,
      revertFileName: result.name,
      selectedResultFileData: result,
    });
  };

  handleScroll = (e) => {
    const {
      searchFilesForReport,
      state: {
        error, hasMore, currentPage, name, isLoadingFileScroll
      },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = e.target;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (error || !hasMore || isLoadingFileScroll) {
      return;
    }
    if (scrolledToBottom) {
      searchFilesForReport(name, currentPage + 1);
    }
  };

  getEmptyReportForEdit = () => {
    const { reportId, translate } = this.props;

    this.setState({
      isLoading: true,
    });

    api
      .getEmptyReportForEdit(reportId)
      .then((res) => {
        const data = convertPropertiesToCamelCase(res.response);
        if (data.checksum === '' && data.name === '') {
          this.modalHeader = translate('modal.title.notice');
          this.modalBody = translate('modal.message.reject_add_scan_result');
          this.setState({
            isOpenAlertModal: true,
            isLoading: false,
          });
        } else {
          this.setState({
            checksum: data.checksum,
            comment: data.comment,
            components: data.components,
            coverage: data.coverage,
            hasGlobalPermission: data.hasGlobalPermission,
            isApplied: data.isApplied,
            name: data.name,
            revertFileName: data.name,
            //projectId: data.projectId,
            //projectName: data.projectName,
            //projectVersionId: data.projectVersionId,
            //projectVersionName: data.projectVersionName,
            //uploadedFileId: data.uploadedFileId,
            selectedResultFileData: {
              name: data.name,
              size: data.size,
              path: data.path,
              realpath: data.realpath,
              relative_name: data.relativeName,
              checksum: data.checksum,
              scan_method: data.scanMethod,
              scan_status: data.scanStatus,
              scan_time: data.scanTime,
              parent_name: data.parentName,
            },
            isLoading: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
        });
      });
  };

  fetchAndUpdateComponentDetails = async (
    updatedComponentList,
    component_name,
    component_version,
    currentId
  ) => {
    const { titleLicenseLoadingIndex, securitiesLoadingIndex, components } = this.state;

    const currentIndex = components.findIndex((item) => {
      return item.id === currentId;
    });

    this.setState({
      titleLicenseLoadingIndex: [
        ...titleLicenseLoadingIndex,
        `title_license_${currentId}`,
      ],
      securitiesLoadingIndex: [
        ...securitiesLoadingIndex,
        `securities_${currentId}`,
      ],
    });

    try {
      const licenseResponse = await this.searchComponentLicenses(
        component_name,
        component_version,
        currentId
      );
      const data = licenseResponse.response;

      if (Object.keys(data[0].license).length === 0) {
        const checkedLicenseResponse = await this.searchComponentLicenses(
          component_name,
          '',
          currentId
        );
        const checkedData = checkedLicenseResponse.response;
        const index = checkedData.findIndex((item) => {
          return Object.keys(item.license).length > 0;
        });

        if (index === -1) {
          updatedComponentList[currentIndex].title_license = '';
        } else {
          const new_version = Object.keys(checkedData[index].license)[0];
          updatedComponentList[currentIndex].title_license = checkedData[index].license[new_version];
        }
      } else {
        updatedComponentList[currentIndex].title_license = data[0].license[component_version];
      }

      const securityResponse = await this.searchComponentSecurities(
        component_name,
        component_version,
        currentId
      );
      const securityData = securityResponse.response;
      updatedComponentList[currentIndex].securities = securityData[0].security_code;
    } catch (error) {
      console.error('Error:', error);
    }

    this.setState({
      components: updatedComponentList,
    });
  };

  updateStateAndValidation = (newState) => {
    this.setState(newState);
  };

  /*
  updateComponentName = (components, index, value) => {
    return Update(components, {
      [index]: {
        component_name: { $set: value }
      }
    });
  };

  updateComponentListFields = (components, index, name) => {
    return Update(components, {
      [index]: {
        component_name: { $set: name },
        component_version: { $set: '' },
        title_license: { $set: '' },
        securities: { $set: [] }
      }
    });
  };
  */

  resetComponentFields = (components, index) => {
    return Update(components, {
      [index]: {
        component_version: { $set: '' },
        title_license: { $set: '' },
        securities: { $set: [] },
      },
    });
  };

  onDragEnd = (result) => {
    const { source, destination } = result;
    const { isChange, components } = this.state;

    if (!result.destination) {
      return null;
    }

    if (
      destination.droppableId === source.droppableId && destination.index === source.index
    ) {
      return null;
    }

    const items = this.reorder(components, source.index, destination.index);

    if (isChange) {
      return this.setState({
        components: items,
      });
    }
    this.setState({
      isChange: true,
      components: items,
    });
  };

  getItemStyle = (isDragging, draggableStyle) => {
    return {
      background: isDragging && '#fae7ff',
      ...draggableStyle,
    };
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return this.resetDisplayPositions(result);
  };

  resetDisplayPositions = (list) => {
    const resetList = list.map((item, index) => {
      const slide = item;
      slide.displayPosition = index + 1;
      return slide;
    });
    return resetList;
  };

  validateForm(component) {
    const { translate } = this.props;
    const validations = [
      {
        key: 'component_name',
        message: 'modal.message.required_component_name',
      },
      {
        key: 'component_version',
        message: 'modal.message.required_component_version',
      },
      { key: 'title_license', message: 'modal.message.required_title_license' },
    ];

    const failedValidation = validations.find((validation) => {
      return component[validation.key] === '';
    });

    if (failedValidation) {
      this.setState({
        errorMessage: translate(failedValidation.message),
      });
      return false;
    }
    return true;
  }

  searchFilesForReport(searchKeyword, page = 1) {
    const { reportId } = this.props;

    this.setState({
      isLoadingFileScroll: true,
    });

    api
      .searchFilesForReport(reportId, {
        search: searchKeyword,
        page,
        limit: 25,
      })
      .then((response) => {
        const data = response.response;

        const newData = data.map((item, index) => {
          return {
            id: (page - 1) * 25 + index,
            checksum: item.checksum,
            full_path: item.full_path,
            name: item.name,
            parent_name: item.parent_name,
            path: item.path,
            realpath: item.realpath,
            relative_name: item.relative_name,
            scan_method: item.scan_method,
            scan_status: item.scan_status,
            scan_time: item.scan_time,
            size: item.size,
          };
        });

        this.setState((prevState) => {
          if (prevState.blurTriggered) {
            return {
              isLoadingFileScroll: false,
              blurTriggered: false,
            };
          }

          return {
            isActiveResult: true,
            resultFileList:
              page === 1 ? newData : [...prevState.resultFileList, ...newData],
            currentPage: response.pagination.current,
            hasMore: response.pagination.next !== null,
            isLoadingFileScroll: false,
          };
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoadingFileScroll: false,
        });
      });
  }

  searchComponentName(searchKeyword, dataType) {
    const { limit, currentId } = this.state;
    const newText = searchKeyword.replace(/\s/g, '') || '';
    api
      .searchPolicyComponent({
        search: newText,
        limit,
      })
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            id: index,
            name: item,
            data_type: dataType,
          };
        });

        if (newText !== '' && data.indexOf(newText) === -1) {
          const newComponent = {
            id: 'exact',
            name: newText,
            data_type: dataType,
          };
          newData.unshift(newComponent);
        }

        this.setState({
          activeIndex: `${dataType}_${currentId}`,
          resultList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  searchComponentVersion(searchKeyword, dataType, componentName) {
    const { limit, currentId } = this.state;
    const newText = searchKeyword.replace(/\s/g, '') || '';
    api
      .searchPolicyVersion({
        search: newText,
        component: componentName,
        limit,
      })
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            id: index,
            name: item,
            data_type: dataType,
          };
        });

        if (newText !== '' && data.indexOf(newText) === -1) {
          const newComponent = {
            id: 'exact',
            name: newText,
            data_type: dataType,
          };
          newData.unshift(newComponent);
        }

        this.setState({
          activeIndex: `${dataType}_${currentId}`,
          resultList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  searchComponentLicense(searchKeyword, dataType) {
    const { limit, currentId } = this.state;
    const newText = searchKeyword.replace(/\s/g, '') || '';
    api
      .searchPolicyLicense({
        search: newText,
        limit,
      })
      .then((response) => {
        const data = response.response;
        const newData = data.map((item, index) => {
          return {
            id: index,
            name: item,
            data_type: dataType,
          };
        });

        if (newText !== '' && data.indexOf(newText) === -1) {
          const newComponent = {
            id: 'exact',
            name: newText,
            data_type: dataType,
          };
          newData.unshift(newComponent);
        }

        this.setState({
          activeIndex: `${dataType}_${currentId}`,
          resultList: newData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async searchComponentLicenses(name, version, id) {
    const { titleLicenseLoadingIndex } = this.state;
    const obj = {
      component_list: [{ component_name: name, component_version: version }],
    };
    try {
      const res = await api.searchComponentLicenses(obj);
      const data = res.response;
      if (
        (version !== '' && Object.keys(data[0].license).length !== 0) || version === ''
      ) {
        const filteredData = titleLicenseLoadingIndex.filter((item) => {
          return item !== `title_license_${id}`;
        });
        this.setState({
          titleLicenseLoadingIndex: filteredData,
        });
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async searchComponentSecurities(name, version, id) {
    const { securitiesLoadingIndex } = this.state;
    const obj = {
      component_list: [{ component_name: name, component_version: version }],
    };
    try {
      const res = await api.searchComponentSecurities(obj);
      const filteredData = securitiesLoadingIndex.filter((item) => {
        return item !== `securities_${id}`;
      });

      this.setState({
        securitiesLoadingIndex: filteredData,
      });
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  textValidation(type, string) {
    /** 숫자 알파벳 ~@^-_+=. 입력 가능 */
    let retValue = true;
    const character = /^[a-zA-Z0-9@\s~^+=._-]+$/;
    //~@^-_+=.-

    if (type === 'component_name' || type === 'component_version') {
      if (!string.match(character)) {
        retValue = false;
        return retValue;
      }
    }
    return retValue;
  }

  closeModal() {
    this.setState({
      isOpenAlertModal: false,
    });
    this.props.closeModal();
  }

  closeCVEModal() {
    this.setState({
      isOpenCVE: false,
    });
  }

  renderSaveBtn() {
    const { translate } = this.props;
    return (
      <a
        className="button save_button"
        onClick={this.handleSave}
        style={{ cursor: 'pointer' }}
      >
        {translate('modal.button.save')}
      </a>
    );
  }

  renderSecurityRow(row, id) {
    const { components, securitiesLoadingIndex } = this.state;
    const findCurrentIndex = components.findIndex((item) => {
      return item.id === id;
    });

    if (securitiesLoadingIndex.indexOf(`securities_${id}`) !== -1) {
      return (
        <div className="hover_area loader_wrap">
          <Table className="sub_table">
            <Table.Body>
              <Table.Row>
                <Table.Cell className="red">0</Table.Cell>
                <Table.Cell className="orange">0</Table.Cell>
                <Table.Cell className="cheese">0</Table.Cell>
                <Table.Cell className="yellow">0</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <Loader className="custom_loader" inline />
        </div>
      );
    }

    let medium = 0;
    let high = 0;
    let critical = 0;
    let low = 0;

    row.forEach((item) => {
      if (item.risk === 'medium') {
        medium += 1;
      } else if (item.risk === 'critical') {
        critical += 1;
      } else if (item.risk === 'high') {
        high += 1;
      } else if (item.risk === 'low') {
        low += 1;
      }
    });
    const security = {
      medium,
      high,
      critical,
      low,
    };

    const customIds = [];

    while (customIds.length < row.length) {
      const r = uuidv4();
      customIds.push(r);
    }

    const newData = row.map((o, index) => {
      return {
        id: customIds[index],
        code: o.code,
        risk: o.risk,
        disabled: true,
      };
    });

    return (
      <div
        className="hover_area"
        onClick={() => {
          return this.handleCVEModalChange(newData, findCurrentIndex);
        }}
      >
        <Table className="sub_table">
          <Table.Body>
            <Table.Row>
              <Table.Cell className="red">{security.critical}</Table.Cell>
              <Table.Cell className="orange">{security.high}</Table.Cell>
              <Table.Cell className="cheese">{security.medium}</Table.Cell>
              <Table.Cell className="yellow">{security.low}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }

  render() {
    const {
      checksum,
      comment,
      components,
      coverage,
      hasGlobalPermission,
      isApplied,
      name,
      selectedRowIds,
      activeIndex,
      resultList,
      errorIndex,
      cveList,
      isOpenCVE,
      currentCVEIndex,
      allSelected,
      titleLicenseLoadingIndex,
      errorMessage,
      isActiveResult,
      isOpenAlertModal,
      isLoadingFileScroll,
      isLoading,
      resultFileList,
    } = this.state;

    const { translate, isOpenMSR, location } = this.props;

    const path = location.pathname ? location.pathname : location;
    const isShowComponent = path.indexOf('settings') !== -1;

    const scan_options = [
      {
        key: 'project',
        text: translate('modal.title.scan_specific_project'),
        value: 'project',
      },
      {
        key: 'company',
        text: translate('modal.title.all_scans'),
        value: 'company',
      },
    ];

    const renderIndeterminate = () => {
      return (
        selectedRowIds.length > 0 && selectedRowIds.length < components.length
      );
    };

    const globalErrorClass = errorMessage !== '' ? 'show' : '';

    const tableHeader = (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell className="icon" style={{ width: '5%' }}>
            <Checkbox
              checked={allSelected}
              indeterminate={renderIndeterminate()}
              onChange={this.handleCheckAllChange}
            />
          </Table.HeaderCell>
          <Table.HeaderCell style={{ width: '25%' }}>
            {translate('list.title.component')}
          </Table.HeaderCell>
          <Table.HeaderCell style={{ width: '25%' }}>
            {translate('list.title.component_version')}
          </Table.HeaderCell>
          <Table.HeaderCell style={{ width: '15%' }}>
            {translate('list.title.title_license')}
          </Table.HeaderCell>
          <Table.HeaderCell style={{ width: '25%' }}>
            {translate('list.title.security')}
          </Table.HeaderCell>
          <Table.HeaderCell style={{ width: '5%' }} />
        </Table.Row>
      </Table.Header>
    );

    const tableRow = (entity, provided, snapshot) => {
      return (
        <Ref innerRef={provided.innerRef}>
          <Table.Row
            {...provided.draggableProps}
            style={this.getItemStyle(
              snapshot.isDragging,
              provided.draggableProps.style
            )}
          >
            <Table.Cell textAlign="center" style={{ width: '5%' }}>
              <Checkbox
                value={entity.id}
                checked={selectedRowIds.indexOf(entity.id) > -1}
                onChange={this.handleCheckChange}
              />
            </Table.Cell>
            <Table.Cell
              style={{ width: '25%' }}
              className={cx('component_name', {
                visible: activeIndex === `component_name_${entity.id}`,
              })}
            >
              <Input
                type="text"
                error={errorIndex.indexOf(`component_name_${entity.id}`) !== -1}
                value={entity.component_name}
                onChange={(e) => {
                  return this.handleChange(
                    entity.id,
                    'component_name',
                    e.target.value
                  );
                }}
                onFocus={(e) => {
                  return this.handleFocus(
                    entity.id,
                    'component_name',
                    e.target.value
                  );
                }}
                onBlur={() => {
                  return this.handleBlurOnName(entity.id);
                }}
              />
              <ResultRenderer
                results={resultList}
                handleResultSelect={this.handleResultSelect}
                isShowResult={activeIndex === `component_name_${entity.id}`}
                translate={translate}
              />
            </Table.Cell>
            <Table.Cell
              style={{ width: '25%' }}
              className={cx('component_version', {
                visible: activeIndex === `component_version_${entity.id}`,
              })}
            >
              <Input
                type="text"
                error={
                  errorIndex.indexOf(`component_version_${entity.id}`) !== -1
                }
                value={entity.component_version}
                onChange={(e) => {
                  return this.handleChange(
                    entity.id,
                    'component_version',
                    e.target.value
                  );
                }}
                onFocus={(e) => {
                  return this.handleFocus(
                    entity.id,
                    'component_version',
                    e.target.value
                  );
                }}
                onBlur={() => {
                  return this.handleBlurOnVersion(entity.id);
                }}
              />
              <ResultRenderer
                results={resultList}
                handleResultSelect={this.handleResultSelect}
                isShowResult={activeIndex === `component_version_${entity.id}`}
                translate={translate}
              />
            </Table.Cell>
            <Table.Cell
              style={{ width: '15%' }}
              className={cx('title_license', {
                visible: activeIndex === `title_license_${entity.id}`,
              })}
            >
              <Input
                type="text"
                loading={
                  titleLicenseLoadingIndex.indexOf(
                    `title_license_${entity.id}`
                  ) !== -1
                }
                disabled={
                  titleLicenseLoadingIndex.indexOf(
                    `title_license_${entity.id}`
                  ) !== -1
                }
                error={errorIndex.indexOf(`title_license_${entity.id}`) !== -1}
                value={entity.title_license}
                onChange={(e) => {
                  return this.handleChange(
                    entity.id,
                    'title_license',
                    e.target.value
                  );
                }}
                onFocus={(e) => {
                  return this.handleFocus(
                    entity.id,
                    'title_license',
                    e.target.value
                  );
                }}
                onBlur={() => {
                  return this.handleBlurOnLicense(entity.id);
                }}
              />
              <ResultRenderer
                results={resultList}
                handleResultSelect={this.handleResultSelect}
                isShowResult={activeIndex === `title_license_${entity.id}`}
                translate={translate}
              />
            </Table.Cell>
            <Table.Cell style={{ width: '25%' }}>
              {this.renderSecurityRow(entity.securities, entity.id)}
            </Table.Cell>
            <Table.Cell style={{ width: '5%' }} textAlign="center">
              <a
                className="drager_button"
                style={{ cursor: 'grab' }}
                {...provided.dragHandleProps}
              >
                <img src={dragbarImg} alt="" />
              </a>
            </Table.Cell>
          </Table.Row>
        </Ref>
      );
    };

    return (
      <Modal open={isOpenMSR} onClose={this.closeModal}>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <div className="setting_popup_wrap">
            <div className="setting_popup default_popup edit_detail scan_result">
              <div className="header_wrap">
                <Header as="h3">
                  {translate('card.menu.add_scan_result')}
                </Header>
                <a
                  className="popup_close_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <div className="header_wrap_error">
                <div className={`error ${globalErrorClass}`}>
                  {errorMessage}
                </div>
              </div>
              <div className="header_input_wrap">
                <div className="setting_popup_content path">
                  <Input
                    className=""
                    type="text"
                    value={name}
                    onChange={this.handleFileNameChange}
                    onFocus={this.handleFileNameFocus}
                    onBlur={this.handleFileNameBlur}
                  >
                    <Icon className="file outline" />
                    <input />
                  </Input>
                  <ResultRendererWithPath
                    results={resultFileList}
                    isLoadingFileScroll={isLoadingFileScroll}
                    handleResultSelect={this.handleFileNameResultSelect}
                    handleScroll={this.handleScroll}
                    isShowResult={isActiveResult}
                    translate={translate}
                  />
                </div>
                <div className="title">
                  <span>{translate('list.title.sha256')}:</span>
                  {checksum}
                </div>
              </div>
              <div className="header_wrap_util path">
                <div className="apply_scan">
                  {typeof hasGlobalPermission === 'boolean' && hasGlobalPermission ? (
                    <Checkbox
                      label={translate('modal.message.apply_next_scan')}
                      checked={isApplied}
                      onChange={this.handleApplyNextScanChange}
                    />
                  ) : null}
                </div>
                {(isShowComponent || isApplied) && (
                  <div className="apply_scan_dropdown_wrap">
                    <Dropdown
                      options={scan_options}
                      value={coverage}
                      onChange={this.handleOptionChange}
                    />
                  </div>
                )}
                <div className="button_wrap">
                  {components.length !== 0 && selectedRowIds.length !== 0 ? (
                    <a
                      className="delete_button util_button"
                      onClick={this.handleDeleteRow}
                    >
                      {translate('modal.button.delete')}
                    </a>
                  ) : (
                    <a
                      className="delete_button util_button"
                      style={{
                        pointerEvents: 'none',
                        cursor: 'default',
                        opacity: '.45',
                      }}
                    >
                      {translate('modal.button.delete')}
                    </a>
                  )}
                  <a
                    className="add_button util_button"
                    onClick={this.handleAddRow}
                  >
                    {translate('modal.button.add')}
                  </a>
                </div>
              </div>
              {!isLoading ? (
                <div>
                  <Table attached="top" fixed>
                    {tableHeader}
                  </Table>
                  <Scrollbars
                    renderTrackHorizontal={() => {
                      return <div />;
                    }}
                    renderThumbHorizontal={() => {
                      return <div />;
                    }}
                    autoHeight
                    autoHeightMin={430}
                    autoHeightMax={430}
                  >
                    <Table attached fixed>
                      <Droppable droppableId="tableBody">
                        {(provided) => {
                          return (
                            <Ref innerRef={provided.innerRef}>
                              <Table.Body {...provided.droppableProps}>
                                {components.map((entity, index) => {
                                  return (
                                    <Draggable
                                      draggableId={entity.id.toString()}
                                      index={index}
                                      key={entity.id}
                                      isDragDisabled={activeIndex !== ''}
                                    >
                                      {(
                                        draggableProvided,
                                        draggableSnapshot
                                      ) => {
                                        const child = tableRow(
                                          entity,
                                          draggableProvided,
                                          draggableSnapshot
                                        );
                                        if (draggableSnapshot.isDragging) {
                                          return (
                                            <Portal
                                              open={
                                                draggableSnapshot.isDragging
                                              }
                                            >
                                              <Table
                                                className="portal_table"
                                                attached
                                                fixed
                                                celled
                                              >
                                                <Table.Body>
                                                  {tableRow(
                                                    entity,
                                                    draggableProvided,
                                                    draggableSnapshot
                                                  )}
                                                </Table.Body>
                                              </Table>
                                            </Portal>
                                          );
                                        }
                                        return child;
                                      }}
                                    </Draggable>
                                  );
                                })}
                                {provided.placeholder}
                              </Table.Body>
                            </Ref>
                          );
                        }}
                      </Droppable>
                    </Table>
                  </Scrollbars>
                  <ModalDescription className="edit_detail_description">
                    <div className="title">
                      {translate('modal.title.comment')}
                    </div>
                    <TextArea
                      disabled={!isApplied && !isShowComponent}
                      value={comment}
                      onChange={this.handleTextAreaChange}
                    />
                  </ModalDescription>
                </div>
              ) : (
                <ClarLoader />
              )}
              <div className="setting_popup_button_wrap">
                <a
                  className="button cencel_button"
                  onClick={this.closeModal}
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.cancel')}
                </a>
                {this.renderSaveBtn()}
              </div>
            </div>
          </div>
        </DragDropContext>
        <EditCveCodeModal
          isOpenCVE={isOpenCVE}
          cveList={cveList}
          translate={translate}
          updateCallback={this.handleCVEDataChange}
          closeModal={this.closeCVEModal}
          currentCVEIndex={currentCVEIndex}
        />
        <Modal open={isOpenAlertModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalHeader}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onKeyUp={this.closeModal}
                    onClick={this.closeModal}
                  >
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(ScanResultModal)));
